export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
              手机观影 · 随时随地
            </h2>
            <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              花生影院移动端适配完美，支持iOS与Android全平台。躺在床上、通勤路上，打开手机就能享受高清电影在线观看，一样流畅不缓冲。收藏夹与观看历史云端同步，换设备也能无缝续看。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-3 px-6 py-3 bg-background-50 rounded-xl cursor-pointer hover:bg-background-100 transition-colors">
                <i className="ri-apple-fill text-2xl text-foreground-800"></i>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">iOS 版本</div>
                  <div className="text-sm font-medium text-foreground-900 whitespace-nowrap">App Store</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-6 py-3 bg-background-50 rounded-xl cursor-pointer hover:bg-background-100 transition-colors">
                <i className="ri-android-fill text-2xl text-foreground-800"></i>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">Android 版本</div>
                  <div className="text-sm font-medium text-foreground-900 whitespace-nowrap">官方下载</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="relative w-48 md:w-56 aspect-[9/16] rounded-3xl overflow-hidden border-4 border-background-50/30 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20movie%20streaming%20app%20interface%20with%20film%20posters%20grid%20layout%2C%20warm%20golden%20amber%20theme%20colors%2C%20modern%20UI%20design%2C%20clean%20minimal%20layout%2C%20cinema%20app%20on%20phone%2C%20dark%20mode%20mobile%20screen%20with%20movie%20thumbnails&width=448&height=796&seq=app-mockup-2026-01&orientation=portrait"
                alt="花生影院手机App界面展示"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}